<template>
  <div>
    <common-header
      title="자녀보호 설정"
      :is-back-btn="true"
      :back-fn="close"
      :is-close-btn="false"
    ></common-header>
    <!-- 신규 영역 -->
    <div v-if="adultVerification !== null" class="parental-control-settings">
      <div class="lnb-list">
        <ul>
          <!--
          2025.04
          19+ 콘텐츠 삭제에 따른 "성인콘텐츠 숨김" 기능 제거
          추후 부활할 경우를 대비하여 로직은 유지하고 UI만 주석처리
          기존 "성인 콘텐츠 숨김" 유저는 "차단하지 않음"으로 변경 (setting 'H' -> 'N')
        -->
          <!--<li @click.prevent="setNewProtectionCode('H', protectValue)">
            <input
              id="parental-control01"
              v-model="protectValue"
              type="radio"
              name="parental-control"
              value="H"
            />
            <label for="parental-control01">
              <strong>
                <span>성인 콘텐츠 숨김</span>
              </strong>
              <p>
                노골적인 성인 콘텐츠를 숨김 처리합니다. (다운로드한 콘텐츠는
                숨김 불가능)<br />* 일반 성인 콘텐츠는 노출됩니다.
              </p>
            </label>
          </li> -->
          <li @click.prevent="setNewProtectionCode('L', protectValue)">
            <input
              id="parental-control02"
              v-model="protectValue"
              type="radio"
              name="parental-control"
              value="L"
            />
            <label for="parental-control02">
              <strong>
                <span>성인 콘텐츠 잠금</span>
                <LockIcon />
              </strong>
              <p>
                성인 콘텐츠 시청 시도 시 성인 비밀번호를 요구합니다.<br />
                Wavve TV 앱에서는 가족이 안심하고 시청할 수 있도록 성인 콘텐츠
                잠금이 유지됩니다.
              </p>
            </label>
          </li>
          <li @click.prevent="setNewProtectionCode('N', protectValue)">
            <input
              id="parental-control03"
              v-model="protectValue"
              type="radio"
              name="parental-control"
              value="N"
            />
            <label for="parental-control03">
              <strong>
                <span>차단하지 않음</span>
                <LockIcon />
              </strong>
              <p>
                모든 성인 콘텐츠가 노출되며 성인 비밀번호 입력 없이 시청
                가능합니다.
              </p>
            </label>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    changeAdultContentProtectionState,
    changeAdultContentProtectionStateForOTT,
    getAdultVerificationStatus,
  } from '@/common/api/api.service'
  import LockIcon from '@/assets/svg/common/ic-lock.svg'
  import utils, { setAdultContentsSettingsValue } from '@/common/util/utils'
  import {
    CONFIRM_CHILDREN_PROTECTION_MESSAGE_HTML,
    ERROR_FROM_ADULT_VERIFICATION_PIN_CODE,
    WHEN_USER_ALLOW_BLOCK_POPUP,
  } from '@/common/message.const'
  import CommonHeader from '@/components/header/template/commonHeader'
  import { removeElement } from '@/common/util/modal.common'
  export default {
    name: 'AdultSettingsTopMenu',
    components: {
      CommonHeader,
      LockIcon,
    },
    data() {
      return {
        protectValue: '',
        adultVerification: null,
        hasAdultVerification: false, // 성인인증 여부 adultverificationsdate
        hasAdultPassCode: false, // 비밀번허 설정 여부 isverify, 이미 pinCode가지고 있는경우
        alreadySetAdultPassCodeByOTT: false, // OTT를 통해 비번을 설정한적 있는지
        popup: null,
      }
    },
    mounted() {
      window.addEventListener('message', this.postMessage)
    },
    created() {
      this.setCurrentState()
    },
    beforeDestroy() {
      window.removeEventListener('message', this.postMessage)
    },
    methods: {
      close() {
        this.$router.back()
      },
      openAdultVerificationAndSetPinCodePopup(protectionCode) {
        // document.domain = DOCUMENT_DOMAIN
        const callback = encodeURIComponent(
          `${window.location.origin}/callback.html?settings=${protectionCode}&action=setPinCode&result=`,
        )
        const url =
          `https://member.wavve.com/mobile/auth/verifyage?type=pin&settings=${protectionCode}` +
          `&device=mobile&credential=${utils.cookies.getCredential()}&callback=${callback}`
        this.popup = window.open(url, '', '')
        if (this.popup) {
          this.popup.window.focus()
        } else {
          alert(WHEN_USER_ALLOW_BLOCK_POPUP)
        }
      },
      commonError(customMessage) {
        alert(
          `${customMessage || '예상치 못한 에러 발생으로 홈으로 이동 합니다.'}`,
        )
        this.$router.replace('/')
      },
      goPinCodePageWithStateCodeForOttUser(stateCode) {
        const popupType = 'adultverify_pin_adult'
        this.$router.replace({
          name: popupType,
          query: {
            referer: this.$route.fullPath,
          },
          params: {
            action: this.buildChangeStateAction(
              stateCode,
              changeAdultContentProtectionStateForOTT,
            ),
            stateCode,
          },
        })
      },
      goPinCodePageWithStateCode(stateCode) {
        const popupType = 'adultverify_pin_children'
        this.$router.replace({
          name: popupType,
          query: {
            referer: this.$route.fullPath,
          },
          params: {
            action: this.buildChangeStateAction(
              stateCode,
              changeAdultContentProtectionState,
            ),
            stateCode,
          },
        })
      },
      async changeAdultContentProtection(protectionCode, fallbackCode) {
        const setFallbackCode = (code) => {
          this.protectValue = code
        }
        if (protectionCode !== 'H') {
          // 숨김은 그냥 패스
          if (this.alreadySetAdultPassCodeByOTT) {
            // isott = y 면 무조건 PC 최초 사용자
            // if (await utils.asyncConfirm(CONFIRM_CHILDREN_PROTECTION_MESSAGE_HTML)) {
            this.goPinCodePageWithStateCodeForOttUser(protectionCode)
            // } else {
            //   setFallbackCode(fallbackCode)
            // }
          } else {
            if (this.hasAdultPassCode) {
              this.goPinCodePageWithStateCode(protectionCode)
            } else {
              if (
                await utils.asyncConfirm(
                  CONFIRM_CHILDREN_PROTECTION_MESSAGE_HTML,
                )
              ) {
                removeElement(document.querySelector('[data-modal="confirm"]'))
                this.openAdultVerificationAndSetPinCodePopup(protectionCode)
              } else {
                setFallbackCode(fallbackCode)
              }
            }
          }
        } else {
          this.buildChangeStateAction(
            'H',
            changeAdultContentProtectionState,
          )({ pincode: '0000' }).then(() => {
            this.setCurrentState()
          })
        }
      },
      buildChangeStateAction(protectionCode, requestFn) {
        return async ({ pincode, resetFn, successFn }) => {
          try {
            const result = await requestFn(pincode, protectionCode)
            const { resultcode } = result.data
            if (resultcode !== '550') {
              await setAdultContentsSettingsValue()
              if (typeof successFn === 'function') {
                successFn()
              } else {
                this.$router.replace('/settings/adult/protect')
              }
            }
          } catch (e) {
            if (typeof resetFn === 'function') {
              resetFn()
            }
          }
        }
      },
      setNewProtectionCode(protectionCode, fallbackCode) {
        if (protectionCode === fallbackCode) return
        this.changeAdultContentProtection(protectionCode, fallbackCode)
      },
      setCurrentState() {
        getAdultVerificationStatus()
          .then(({ data }) => {
            this.adultVerification = data
            const {
              isverify = 'n',
              isott = 'n',
              adultverificationdate = '',
              settings = 'N',
            } = this.adultVerification
            this.hasAdultPassCode = isverify !== 'n'
            this.hasAdultVerification = adultverificationdate !== ''
            this.alreadySetAdultPassCodeByOTT = isott !== 'n'
            this.protectValue = settings
          })
          .catch(() => {
            this.commonError()
          })
      },
      postMessage(e) {
        if (
          e.origin === location.origin &&
          e.data.eventMessage === 'setPinCode'
        ) {
          if (e.data.result === 'true') {
            this.protectValue = e.data.settings
            this.setCurrentState()
          } else {
            alert(ERROR_FROM_ADULT_VERIFICATION_PIN_CODE)
            this.setCurrentState()
          }
          this.popup.close()
        }
      },
    },
  }
</script>
<style lang="css" src="@/assets/new-css/home-gnb.css"></style>
<style lang="css" src="@/assets/new-css/lnb.css"></style>
<style lang="css" src="@/assets/new-css/adult.css"></style>
